import type {
  CreateGreetingTemplateRequest,
  GreetingTemplateDto,
  SendGreetingRequest,
  SendGreetingResponse,
  UpdateGreetingTemplateRequest,
} from '@ledokol/contracts'
import { api } from './client'

/** #6 — шаблоны поздравлений + отправка. Всё под правом greetings.manage. */
export async function fetchGreetingTemplates(): Promise<GreetingTemplateDto[]> {
  const r = await api.get<GreetingTemplateDto[]>('/greetings/templates')
  return r.data
}
export async function createGreetingTemplate(body: CreateGreetingTemplateRequest): Promise<GreetingTemplateDto> {
  const r = await api.post<GreetingTemplateDto>('/greetings/templates', body)
  return r.data
}
export async function updateGreetingTemplate(id: string, body: UpdateGreetingTemplateRequest): Promise<GreetingTemplateDto> {
  const r = await api.patch<GreetingTemplateDto>(`/greetings/templates/${id}`, body)
  return r.data
}
export async function deleteGreetingTemplate(id: string): Promise<void> {
  await api.delete(`/greetings/templates/${id}`)
}
export async function sendGreeting(body: SendGreetingRequest): Promise<SendGreetingResponse> {
  const r = await api.post<SendGreetingResponse>('/greetings/send', body)
  return r.data
}
